<div class="appointment">
        
        <form [formGroup]='customerInfo'>

    <ng-template [ngIf]="location=='DEALER'">
        <div class="address">
            <h5>{{dealerAddressForRadio.dealerName}}</h5>
            <div style="font-weight: bold;">{{dealerAddressForRadio.address.addressLine1}} {{dealerAddressForRadio.address.addressLine2}} {{dealerAddressForRadio.address.city}}, {{dealerAddressForRadio.address.state}} {{dealerAddressForRadio.address.zip}}</div>
            <div style="font-weight: bold;">{{dealerPhoneNumber}}</div>
        </div>
    </ng-template>

    <ng-template [ngIf]="location=='REMOTE'">
                
        <div class='location-details'>
          <app-shared-address [form]="customerInfo" 
          [zipCodes]="remoteValidZipcodes" 
          (zipChange)="zipChange($event)"
          [formStates]="formStates['address'].states"
          [formcities]="formcities['address'].cities.statecities"
          [remotelocation]="location=='REMOTE'"
          (addressChange)="updateAddressFields($event,'pickUpAddress')"
          [isZipValid]="isZipValid"
          >
          </app-shared-address>
        </div> 
      </ng-template>

       </form>

</div>